<script>
import { Chrome } from '@lk77/vue3-color';
import { anchoredPanelStyle } from 'dashboard/helper/anchoredPanel';

// O painel vai para o <body> e se posiciona pelo swatch. Dentro do componente
// ele era `absolute`, e qualquer ancestral com overflow-hidden — todo cartão
// arredondado do CRM — cortava o seletor pela metade (z-index não resolve:
// overflow recorta o filho independentemente da camada).

export default {
  components: {
    Chrome,
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      isPickerOpen: false,
      panelStyle: {},
    };
  },
  beforeUnmount() {
    this.unwatchViewport();
  },
  methods: {
    closeTogglePicker() {
      if (this.isPickerOpen) {
        this.toggleColorPicker();
      }
    },
    toggleColorPicker() {
      this.isPickerOpen = !this.isPickerOpen;
      if (this.isPickerOpen) {
        this.positionPanel();
        // Segunda passada com o painel já medido (a primeira usa o tamanho
        // estimado só para não abrir piscando no canto).
        this.$nextTick(this.positionPanel);
        this.watchViewport();
      } else {
        this.unwatchViewport();
      }
    },
    watchViewport() {
      // captura: o painel é fixed, então precisa acompanhar QUALQUER container
      // que role, não só a janela.
      window.addEventListener('scroll', this.positionPanel, true);
      window.addEventListener('resize', this.positionPanel);
    },
    unwatchViewport() {
      window.removeEventListener('scroll', this.positionPanel, true);
      window.removeEventListener('resize', this.positionPanel);
    },
    positionPanel() {
      this.panelStyle = anchoredPanelStyle(
        this.$refs.swatch,
        this.$refs.panel?.$el
      );
    },
    updateColor(e) {
      this.$emit('update:modelValue', e.hex);
    },
  },
};
</script>

<template>
  <div class="colorpicker">
    <div
      ref="swatch"
      class="colorpicker--selected"
      :style="`background-color: ${modelValue}`"
      @click.prevent="toggleColorPicker"
    />
    <Teleport to="body">
      <Chrome
        v-if="isPickerOpen"
        ref="panel"
        v-on-clickaway="closeTogglePicker"
        disable-alpha
        :model-value="modelValue"
        class="colorpicker--chrome"
        :style="panelStyle"
        @update:model-value="updateColor"
      />
    </Teleport>
  </div>
</template>

<style scoped lang="scss">
.colorpicker {
  position: relative;
}

.colorpicker--selected {
  @apply border border-solid border-n-weak rounded cursor-pointer h-8 w-8 mb-4;
}

.colorpicker--chrome.vc-chrome {
  @apply shadow-lg fixed z-[9999] border border-solid border-n-weak rounded;

  ::v-deep {
    input {
      @apply bg-white dark:bg-white;
    }
  }
}
</style>
